import { LeaderModeType } from 'types/LeaderModeTypes';
import { UserType } from 'types/UserTypes';

export const getDebugButtonOpacity = (userType: UserType, leaderMode: LeaderModeType) =>
  leaderMode === LeaderModeType.TutorLeaderMode && userType === UserType.Student ? 0.5 : 1;

export const getDebugButtonDisabled = (userType: UserType, leaderMode: boolean) =>
  leaderMode && userType === UserType.Student;
